import styled from 'styled-components'

export default styled.div`
  flex: 1;
  padding: 20px;
`